export enum FormSectionContainerGrid {
  Standard = 'standard',
  Wide = 'wide'
}
